// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const LIST_WIF_AUTH_BINDINGS =
  "mondoo.captain.Captain.ListWIFAuthBindings";
